import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxCaptchaModule } from 'ngx-captcha';
import {
  ButtonDirective,
  CheckboxDirective,
  InputModule,
  InputLabelDirective,
  FormFieldDirective,
  FormErrorDirective,
  FormDescriptionDirective,
  LabelDirective
} from '@limehome/spark-ui-angular';
import { NgIconsModule } from '@ng-icons/core';
import { BookingParamsService } from '../../../core/services/booking-params/booking-params.service';
import { HeaderComponent } from '../../../home/components/header/header.component';
import { HttpLoaderFactory } from '../../../utils/loader-factory/loader-factory';
import { AuthModalComponent } from '../../components/auth-modal/auth-modal.component';
import { CalendarComponent } from '../../components/calendar/calendar.component';
import { FormatDayPipe } from '../../components/calendar/pipes/format-day/format-day.pipe';
import { IsDateSelectedPipe } from '../../components/calendar/pipes/is-date-selected/is-date-selected.pipe';
import { IsEndDatePipe } from '../../components/calendar/pipes/is-end-date/is-end-date.pipe';
import { IsHoveredPipe } from '../../components/calendar/pipes/is-hovered/is-hovered.pipe';
import { IsInsidePipe } from '../../components/calendar/pipes/is-inside/is-inside.pipe';
import { IsRangePipe } from '../../components/calendar/pipes/is-range/is-range.pipe';
import { IsStartDatePipe } from '../../components/calendar/pipes/is-start-date/is-start-date.pipe';
import { CityPickerComponent } from '../../components/city-picker/city-picker.component';
import { DatePickerComponent } from '../../components/date-picker/date-picker.component';
import { GuestPickerComponent } from '../../components/guest-picker/guest-picker.component';
import { HeaderMenuComponent } from '../../components/header-menu/header-menu.component';
import { HowItWorksComponent } from '../../components/how-it-works/how-it-works.component';
import { InfoModalComponent } from '../../components/info-modal/info-modal.component';
import { LoadingPlaceholderComponent } from '../../components/loading-placeholder/loading-placeholder.component';
import { LogoComponent } from '../../components/logo/logo.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ReferenceInfoComponent } from '../../components/reference-info/reference-info.component';
import { AppHostDirective } from '../../directives/app-host/app-host.directive';
import { ClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';
import { CollapseDirective } from '../../directives/collapse/collapse.directive';
import { DirectivesModule } from '../../directives/directive.module';
import { DropDownPositionDirective } from '../../directives/drop-down-position/drop-down-position.directive';
import { OpenDropdownDirective } from '../../directives/open-dropdown/open-dropdown.directive';
import { TogglePasswordDirective } from '../../directives/toggle-password/toggle-password.directive';
import { AddClassListPipe } from '../../pipes/add-class-list/add-class-list.pipe';
import { FormatDatePipe } from '../../pipes/format-date/format-date.pipe';
import { ParseIsoPipe } from '../../pipes/parse-iso/parse-iso.pipe';
import { LoadingIndicatorModule } from '../loading-indicator/loading-indicator.module';
import { LocalizePipeModule } from '../localize-pipe/localize-pipe.module';
import { SwiperDirective } from '../../directives/swiper/swiper.directive';
import { PluralizePipeModule } from '../pluralize-pipe/pluralize-pipe.module';
import {
  faSolidCircleCheck,
  faSolidCircleInfo,
  faSolidCircleQuestion,
  faSolidTriangleExclamation
} from '@ng-icons/font-awesome/solid';

@NgModule({
  declarations: [
    AddClassListPipe,
    AppHostDirective,
    AuthModalComponent,
    CalendarComponent,
    CityPickerComponent,
    ClickOutsideDirective,
    CollapseDirective,
    DatePickerComponent,
    DropDownPositionDirective,
    FormatDatePipe,
    FormatDayPipe,
    GuestPickerComponent,
    HeaderComponent,
    HeaderMenuComponent,
    HowItWorksComponent,
    InfoModalComponent,
    IsDateSelectedPipe,
    IsEndDatePipe,
    IsHoveredPipe,
    IsInsidePipe,
    IsRangePipe,
    IsStartDatePipe,
    LoadingPlaceholderComponent,
    LogoComponent,
    ModalComponent,
    OpenDropdownDirective,
    ParseIsoPipe,
    ReferenceInfoComponent,
    SwiperDirective,
    TogglePasswordDirective
  ],
  imports: [
    ButtonDirective,
    CheckboxDirective,
    CommonModule,
    DirectivesModule,
    FormDescriptionDirective,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    FormErrorDirective,
    FormErrorDirective,
    FormFieldDirective,
    FormsModule,
    InputLabelDirective,
    InputModule,
    LabelDirective,
    LoadingIndicatorModule,
    LocalizePipeModule,
    NgbDatepickerModule,
    NgOptimizedImage,
    NgxCaptchaModule,
    PluralizePipeModule,
    ReactiveFormsModule,
    RouterModule,
    NgIconsModule.withIcons({
      faSolidTriangleExclamation,
      faSolidCircleCheck,
      faSolidCircleInfo,
      faSolidCircleQuestion
    })
  ],
  exports: [
    AddClassListPipe,
    AppHostDirective,
    AuthModalComponent,
    ButtonDirective,
    CalendarComponent,
    CheckboxDirective,
    CityPickerComponent,
    ClickOutsideDirective,
    CollapseDirective,
    DatePickerComponent,
    DropDownPositionDirective,
    FormatDatePipe,
    FormDescriptionDirective,
    FormErrorDirective,
    FormFieldDirective,
    FormsModule,
    GuestPickerComponent,
    HeaderComponent,
    HeaderMenuComponent,
    HowItWorksComponent,
    InfoModalComponent,
    InputLabelDirective,
    InputModule,
    IsDateSelectedPipe,
    IsEndDatePipe,
    IsStartDatePipe,
    LabelDirective,
    LabelDirective,
    LoadingIndicatorModule,
    LoadingPlaceholderComponent,
    LogoComponent,
    ModalComponent,
    NgbDatepickerModule,
    OpenDropdownDirective,
    ParseIsoPipe,
    ReactiveFormsModule,
    ReferenceInfoComponent,
    RouterModule,
    SwiperDirective,
    TogglePasswordDirective,
    TranslateModule
  ],
  providers: [BookingParamsService]
})
export class CommonAppModule {}
